import { render, staticRenderFns } from "./Lista-Bolle.vue?vue&type=template&id=8748bd4e&scoped=true&"
import script from "./Lista-Bolle.vue?vue&type=script&lang=js&"
export * from "./Lista-Bolle.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Bolle.vue?vue&type=style&index=0&id=8748bd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8748bd4e",
  null
  
)

export default component.exports